import React from 'react'
import './Common.css'
const Footer = () => {
  return (
    <footer className='footer'>
        <span>
        Copyrights 2023 &copy; MeAbhinav kumar </span>
    </footer>
  )
}

export default Footer